export const TEST_IDS = {
  shipmentOfferRow: 'shipmentOfferRow',
  shipmentOfferRowButtons: {
    container: 'ShipmentOfferRowButtons',
    declineButton: 'decline-button',
    acceptButton: 'accept-offer-button',
    errorMessage: 'offer-error-message',
  },
  shipmentOfferRowExpiration: {
    container: 'ShipmentOfferRowExpiration',
    clockIcon: 'clock-icon',
    expirationText: 'expiration-text',
  },
  declineShipmentOfferConfirmationModal: {
    container: 'DeclineShipmentOfferConfirmationModal',
    cancelButton: 'cancel-button',
    declineOfferButton: 'decline-offer-button',
  },
}

export const TOTAL_LOADS_PER_PAGE = 20
export const SHIPMENT_OFFER_PARAM = 'isShipmentOffer'
